import { LocalizedStringsMethods } from "react-localization";
import { DynamicFormControl }from "../../../";
import SanitizedHtml from "../../helpers/sanitized-html";
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";

/** Sanitize and display HTML content stored in props.label */
function HtmlControl(props: DynamicFormControl) {
    const { currentLanguage } = useTranslateDetection();
    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);
    let label = props.label;

    if (strings != null && label != null) {
        const localization = localizeText(strings, label);
        label = localization.localization;
    }
    
    return (
        <SanitizedHtml html={label}></SanitizedHtml>
    )
}


export default HtmlControl;